// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
var sectionClass = "Home_homeSection__0iuvX";
var sectionHeaderClass = "Home_homeSectionHeader__0iuvX";
export { sectionClass, sectionHeaderClass };
